import { jsxs, jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { memo } from "react";
import { DualGridCardLayoutContentWrapper } from "../components/content-wrapper.es.js";
import { DualGridCardLayoutContent } from "../components/content.es.js";
import { DualGridCardLayoutColumn } from "../components/column-container.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
function generateDualGridCardLayoutElement({
  titleContent,
  startContent,
  endContent
}) {
  return /* @__PURE__ */ jsxs(DualGridCardLayoutColumn, { children: [
    /* @__PURE__ */ jsx(DualGridCardLayoutContentWrapper, { gap: Spacing["500"], children: titleContent }),
    /* @__PURE__ */ jsxs(DualGridCardLayoutContentWrapper, { gap: Spacing["2000"], children: [
      /* @__PURE__ */ jsx(DualGridCardLayoutContent, { children: startContent }),
      /* @__PURE__ */ jsx(DualGridCardLayoutContent, { children: endContent })
    ] })
  ] });
}
const DualGridCardLayoutElement = memo(generateDualGridCardLayoutElement);
export {
  DualGridCardLayoutElement
};
//# sourceMappingURL=card-element.es.js.map
